/* État des carrousels ; le défilement reste géré par le thème existant. */
(() => {
  'use strict';
  if (window.Sn32Experience) return;
  const instances = new Map();
  const initialise = scope => {
    scope.querySelectorAll('.menu-drawer__close-menu-btn:not([aria-label])').forEach(button => {
      button.setAttribute('aria-label', 'Fermer le menu');
    });
    const rails = [...scope.querySelectorAll('[data-sn17-rail]')];
    if (scope.matches?.('[data-sn17-rail]')) rails.unshift(scope);
    rails.forEach(rail => {
      if (instances.has(rail)) return;
      const track = rail.querySelector('[data-sn17-track]');
      const previous = rail.querySelector('[data-sn17-scroll="-1"]');
      const next = rail.querySelector('[data-sn17-scroll="1"]');
      const position = rail.querySelector('[data-sn32-position]');
      if (!track || !previous || !next) return;
      const abort = new AbortController();
      let frame = 0;
      const update = () => {
        frame = 0;
        const bounds = track.getBoundingClientRect();
        const cards = [...track.children];
        const visible = cards.map((card,index) => ({ index, rect: card.getBoundingClientRect() }))
          .filter(({ rect }) => rect.right > bounds.left + 8 && rect.left < bounds.right - 8);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (position && visible.length) {
          const start = visible[0].index + 1;
          const end = visible[visible.length - 1].index + 1;
          position.textContent = `${start === end ? start : `${start}–${end}`} / ${cards.length}`;
        }
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      track.addEventListener('scroll', schedule, { passive: true, signal: abort.signal });
      const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      if (resize) resize.observe(track);
      else window.addEventListener('resize', schedule, { passive: true, signal: abort.signal });
      instances.set(rail, () => { abort.abort(); resize?.disconnect(); cancelAnimationFrame(frame); });
      update();
    });
  };
  const destroy = scope => instances.forEach((cleanup, rail) => {
    if (scope === rail || scope.contains(rail)) { cleanup(); instances.delete(rail); }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('details[id^="Sn18Menu"][open]');
    if (!menu) return;
    menu.open = false;
    const summary = menu.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'false');
    summary?.focus();
  });
  window.Sn32Experience = { initialise, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
})();
